module.exports = __webpack_public_path__ + "static/media/star.f45f3eb5.svg";